import * as React from "react";

const MinusIcon: React.FC = () => {
    return (
        <svg width="20" height="4" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.25 3.5H1.75C0.920781 3.5 0.25 2.82875 0.25 1.99953C0.25 1.17031 0.920781 0.5 1.75 0.5H18.25C19.0792 0.5 19.75 1.17031 19.75 1.99953C19.75 2.82875 19.0797 3.5 18.25 3.5Z" fill="#262525"/>
</svg>
    );
};

export default React.memo(MinusIcon);
